import { useEffect } from 'react'
import { Button } from '@shopflo/ui'
import { useLocale } from 'src/lib/hooks/useLocal'
import { Eye, EyeSlash } from '@phosphor-icons/react'
import FormTile from 'src/components/common/containers/FormTile'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import { NumberStepper } from 'src/components/common/NumberStepper/NumberStepper'
import { useCustomizeUIContext } from 'src/lib/contexts/CustomizeUIProvider'
import { useDelhiveryPreview } from 'src/lib/contexts/DelhiveryPreviewContext'
import { DELHIVERY_CONFIRMATION_DIALOG_KEY, defaultDelhiveryDialogConfig } from 'src/assets/CustomizeUIConfig'
import { DialogDisplayConfigType } from 'src/lib/types/customizeUI'

const AddressConfirmationEditor: React.FC<{ canEdit: boolean }> = ({ canEdit }) => {
  const { t } = useLocale()
  const dialogDisplayConfig = useCustomizeUIContext(c => c.state.dialogDisplayConfig)
  const setDialogDisplayConfigData = useCustomizeUIContext(c => c.actions.setDialogDisplayConfigData)
  const { showDelhiveryPreview, setShowDelhiveryPreview } = useDelhiveryPreview()

  const delhiveryConfirmationConfig = dialogDisplayConfig.find(
    dialog => dialog.key === DELHIVERY_CONFIRMATION_DIALOG_KEY
  )
  console.log(delhiveryConfirmationConfig)

  const updateDelhiveryDialog = (updates: Partial<DialogDisplayConfigType>) => {
    setDialogDisplayConfigData(
      delhiveryConfirmationConfig
        ? dialogDisplayConfig.map(dialog =>
            dialog.key === DELHIVERY_CONFIRMATION_DIALOG_KEY ? { ...dialog, ...updates } : dialog
          )
        : [...dialogDisplayConfig, { ...defaultDelhiveryDialogConfig, ...updates }]
    )
  }

  const isEnabled = Boolean(delhiveryConfirmationConfig?.enabled)
  const durationInSeconds =
    delhiveryConfirmationConfig && delhiveryConfirmationConfig.duration > 0
      ? Math.round(delhiveryConfirmationConfig.duration / 1000)
      : 3

  useEffect(() => {
    if (!isEnabled) setShowDelhiveryPreview(false)
  }, [isEnabled])

  return (
    <FormTile
      title={t('address_confirmation_popover_title')}
      subtitle={t('address_confirmation_popover_subtitle')}
      endComponent={
        <div className='flex items-center gap-2 flex-shrink-0 p-4'>
          {isEnabled && (
            <Button
              variant='ghost'
              size='sm'
              leftIcon={showDelhiveryPreview ? EyeSlash : Eye}
              onClick={() => {setShowDelhiveryPreview(!showDelhiveryPreview)}}
            >
              {showDelhiveryPreview ? t('exit_nudge.hide_preview') : t('exit_nudge.show_preview')}
            </Button>
          )}
          <FloCheckbox
            type='SWITCH'
            isDisabled={!canEdit}
            value={isEnabled}
            setValue={(checked: boolean) => {
              updateDelhiveryDialog({ enabled: checked })
            }}
          />
        </div>
      }
     className='!gap-0 '
    >
      <>
        {isEnabled && (
          <div className='flex items-center gap-2 justify-between pt-4 border-t border-black/5' >
          <p className='text-text-sm-medium text-zinc-600'>{t('delhivery_confirmation_auto_close_label')}</p>
          <NumberStepper
            value={durationInSeconds}
            min={2}
            max={7}
            step={1}
            disabled={true}
            setValue={(value: number | string) => {
              updateDelhiveryDialog({ duration: parseInt(value.toString()) * 1000 })
            }}
            customizeUIClasses={{ label: 'text-xs text-zinc-700 !font-normal', container: '!gap-1 !items-end' }}
            suffix='s'
            label=''
          />
          </div>
        )}
      </>
    </FormTile>
  )
}

export default AddressConfirmationEditor
